<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#user-add-s"></use></svg>
  Opret bruger med brik, uden invitation
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<form [formGroup]="userFormGroup" (ngSubmit)="save()">
  <mat-dialog-content>
    <div class="feedback-dialog-container">
      <ok-feedback-info>
        <div>
          <strong>Info omkring oprettelse</strong>
          <br />
          Brugeren bliver oprettet, og der skal manuelt indtastes information om brugeren.
        </div>
      </ok-feedback-info>
    </div>

    <div class="form-row">
      <adm-org-typeahead
        [initialId]="data.organization ? data.organization.id : undefined"
        [resetTrigger]="resetOrgTrigger()"
        (itemSelected)="organizationSelected($event)"
        (clearTypeAhead)="resetOrganization()" />
    </div>
    <div class="form-row">
      @let selectedDepartment = userFormGroup.controls.department.value;
      <adm-dep-typeahead
        [organizationId]="userFormGroup.controls.organization.value?.id ?? null"
        [departmentId]="selectedDepartment ? selectedDepartment.id.toString() : null"
        [disabled]="departmentsDisabled()"
        (itemSelected)="departmentSelected($event)"
        [resetTrigger]="resetDepartmentTrigger()" />
    </div>
    @if (userFormGroup.controls.organization.value) {
      <div class="form-row">
        <mat-label class="bold">Har brugeren firmabil hos {{ userFormGroup.controls.organization.value.name }}</mat-label>
        <mat-radio-group formControlName="userHaveOrganizationCar" name="userHaveOrganizationCar">
          <mat-radio-button [value]="true">
            <span [class.bold]="userFormGroup.controls.userHaveOrganizationCar.value">Ja</span>
          </mat-radio-button>
          <mat-radio-button [value]="false">
            <span [class.bold]="!userFormGroup.controls.userHaveOrganizationCar.value">Nej</span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    }
    <div class="form-row">
      <mat-form-field class="mdc-textarea-fix">
        <mat-label>Vælg adgangsgrupper</mat-label>
        <mat-select required [formControl]="userFormGroup.controls.selectedAccessGroups" multiple okCustomDropDownArrowDirective>
          <mat-select-trigger>
            {{ userFormGroup.controls.selectedAccessGroups.value[0]?.name || '' }}
            @if (userFormGroup.controls.selectedAccessGroups.value.length > 1) {
              <span class="example-additional-selection">
                (+{{ userFormGroup.controls.selectedAccessGroups.value.length - 1 }}
                {{ userFormGroup.controls.selectedAccessGroups.value.length === 2 ? 'mere' : 'flere' }})
              </span>
            }
          </mat-select-trigger>
          @for (accessGroup of accessGroups$ | async; track accessGroup) {
            <mat-option [value]="accessGroup">{{ accessGroup.name }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>
    <ng-container>
      <div class="form-row">
        <mat-form-field>
          <mat-label>Navn</mat-label>
          <input matInput placeholder="Navn på brugeren" maxlength="75" formControlName="name" required value="" />
          @if (userFormGroup.controls.name.invalid) {
            <mat-error>Indtast venligst navn</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-row">
        <adm-dep-address-typeahead
          [parentFormGroup]="userFormGroup"
          [addressWithoutDARValidation]="false"
          (addressSelected)="selectAddress($event)" />
      </div>
      <div class="form-row">
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input matInput placeholder="Brugerens email adresse" maxlength="100" required="" formControlName="email" email />
          @if (userFormGroup.controls['email'].invalid) {
            <mat-error>{{ getErrorMessage('emailAddress') }}</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-row">
        <div class="grid-cols">
          <adm-country-code-selector [formItem]="userFormGroup.controls.countryCode" />
          <adm-phone-number-input [formItem]="userFormGroup.controls.phoneNumber" [countryCode]="userFormGroup.controls.countryCode" />
        </div>
      </div>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" mat-button mat-dialog-close>Annuller</button>
    <button class="actions__button" type="submit" mat-flat-button color="primary" [disabled]="userFormGroup.invalid">Gem</button>
  </mat-dialog-actions>
</form>
